import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.collapsedView ? "d-flex flex-column" : "d-flex align-center" },
    [
      _c(
        "div",
        {
          staticClass: "pricing-group-title d-flex align-center",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.selectUnit.apply(null, arguments)
            },
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.unit.levelEntryDescription) + "\n    "),
          !_vm.preventUnitSelection
            ? _c(
                VIcon,
                { staticClass: "ml-2", attrs: { small: "", color: "primary" } },
                [_vm._v("\n      mdi-open-in-new\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isSelectable
        ? _c(
            "div",
            { staticClass: "d-flex ml-3 align-center" },
            [
              _vm._l(_vm.kpiData, function (icon, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "mr-1" },
                  [
                    _c("work-packages-unit-kpi-icon-new", {
                      attrs: {
                        number: icon.number,
                        "tooltip-message": icon.tooltipMessage,
                        rejected: icon.rejected,
                        "user-role": icon.userRole,
                        shape: icon.shape,
                        "bg-color": icon.bgColor,
                        "text-color": icon.textColor,
                        "outline-color": icon.outlineColor,
                      },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mr-1" },
                [
                  _c("approval-icon-new", {
                    attrs: {
                      approved: _vm.unitComplete,
                      "unit-level": true,
                      "tooltip-message": _vm.$t("workPackages.unitComplete"),
                    },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }